export default __webpack_public_path__ + "static/media/Wildthorn Band.60517e8a.jpg";